import bwipjs from 'bwip-js';

export default class BarcodeGenerator {
    constructor() {
        this.handlers = document.querySelectorAll('.barcode');
        if (this.handlers.length === 0) return;
        this.renderAll();
    }

    renderAll() {
        this.handlers.forEach(async (el) => {
            const type = el.dataset.type.toLowerCase();
            const value = el.dataset.value || '';

            if (!value) return;

            el.innerHTML = ''; // Clear previous content

            const options = {
                bcid: type,
                text: value,
                scale: 3,           // scale works with SVG
                includetext: false,
                padding: 0,
                // extra options for PDF417
                ...(type === 'pdf417' ? { columns: 5 } : {}),
            };

            try {
                // Use toSVG to get SVG string
                const svg = await bwipjs.toSVG(options);
                // svg is a string with SVG XML

                el.innerHTML = svg;
            } catch (err) {
                console.error('Barcode generation error:', err);
                el.textContent = 'Invalid barcode data';
            }
        });
    }
}
